






























































































import { Component, Vue, Watch } from "vue-property-decorator";
import { hotSearch, queryPrefix, delHistory, getCueWord } from "@/req/home";
import QRCode from "qrcodejs2";
import { logout } from "@/req/user";
import VueClipboard from "vue-clipboard2"; // 复制粘贴插件
Vue.use(VueClipboard);
@Component({
  components: { QRCode },
})
@Component
export default class Home extends Vue {
  public qrcodeBox: any = null;
  public confirmFn: any = null;
  public url = "";
  public mburl = "";
  public active = 2;
  public downloadText: any = "下载996盒子客户端";
  public Height = 0;
  // 3差img
  public imgList: any = [
    {
      title: "千万玩家聚集，新一代传奇系列游戏平台",
      desc: "最新开服速览，游戏详情 | 视频 | 截图，全方位一览无余",
      imgUrl: "/static/img/download/img_one.png",
      bgImgUrl: "/static/img/download/bgimg_one.png",
      clas: "list",
    },
    {
      title: "三端互通，随时随地开启传奇人生",
      desc: "PC端 | Android端 | IOS端 数据互通，任意畅玩",
      imgUrl: "/static/img/download/img_two.png",
      bgImgUrl: "/static/img/download/bgimg_two.png",
      clas: "list_one",
    },
    {
      title: "一键登录，996盒子通行证畅玩传奇游戏",
      desc: "游戏账号和996盒子账号互通，三端尽情畅玩",
      imgUrl: "/static/img/download/img_three.gif",
      bgImgUrl: "/static/img/download/bgimg_three.png",
      clas: "list_ones",
    },
    {
      title: "「 交易行 」上线 游戏随心交易",
      desc: "自由定价 | 快捷交易 | 角色、元宝、金币全线打通",
      imgUrl: "/static/img/download/img_four.png",
      bgImgUrl: "/static/img/download/bgimg_four.png",
      clas: "list_one",
    },
    {
      title_one: "超全",
      title_two: "任务系统",
      title_three: "即将上线",
      title_four: "任务轻松 奖励丰厚",
      desc: "免费领取，新服领先一步",
      imgUrl: "/static/img/download/img_five.png",
      bgImgUrl: "/static/img/download/bgimg_five.png",
      clas: "list_two",
    },
    {
      title_one: "",
      title_two: "礼包系统",
      title_three: "敬请期待",
      title_four: "汇总全网传奇游戏礼包",
      desc: "娱乐消遣好去处，一边打游戏，一边能赚钱",
      imgUrl: "/static/img/download/img_six.png",
      bgImgUrl: "/static/img/download/bgimg_six.png",
      clas: "list_two",
    },
    {
      title_one: "",
      title_two: "传奇社区",
      title_three: "敬请期待",
      title_four: "全网首个传奇品类社区",
      desc: "家族、散人聚集地，分享交流，凝聚好友兄弟情",
      imgUrl: "/static/img/download/img_seven.png",
      bgImgUrl: "/static/img/download/bgimg_seven.png",
      clas: "list_two",
    },
  ];
  //  生成二维码
  public mounted() {
    this.getLink();
    this.downloadText = this.downloadText.split("");
  }
  @Watch("$store.state.user.minHeight")
  public change() {
    this.Height =
      this.$store.state.user.minHeight >= 720
        ? this.$store.state.user.minHeight
        : 720;
  }

  public async getLink() {
    this.Height =
      this.$store.state.user.minHeight >= 720
        ? this.$store.state.user.minHeight
        : 720;
    const res = await this.$fn.getGameLinks();
    this.url = res.pc_down_url;
    this.mburl = res.android_down_url;
    this.getQrcode();
  }
  public getQrcode() {
    this.qrcodeBox = new QRCode("qrcodes", {
      width: 180,
      height: 180, // 高度
      text: "http://land.996box.com/mobilepage/index.html", // 二维码内容
      // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
      // background: '#f0f',   // 背景色
      // foreground: '#ff0'    // 前景色
    });
  }
  public onDownloadmB() {
    window.location.href = this.mburl;
  }
  public onDownloadpc() {
    window.location.href = this.url;
  }
}
